import { getGuid } from 'owa-guid';
import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import { addSessionMutator } from '../mutators/sessionMutators';
import type { MailboxInfo } from 'owa-client-types';

/**
 * Initializes a new session for a new consumer of the cache
 * @param mailboxInfo Account for this session
 * @param filterEvent Optional CalendarEvent to filter out of the response
 */
export function initializeCacheSession(
    mailboxInfo: MailboxInfo,
    filterEvent?: CalendarEvent
): string {
    const sessionId = getGuid();

    addSessionMutator(sessionId, mailboxInfo, filterEvent);

    return sessionId;
}
